export const current_trips_events = {
  current_trips_page_loads: {
    category: "User loads Current trip page",
    action: "User clicks on Current trip button from the side bar",
    label: "current-trips-page-loads",
  },
  today_explore_city_click: {
    category: "User navigates to explore city page",
    action: "User clicks on explore city button",
    label: "today-explore-city-click",
  },
  today_view_trip_details_click: {
    category: "User navigates to trip details page",
    action: "The user clicks on view trip details image card",
    label: "today-view-trip-details-click",
  },
  today_zenvoya_assistance_click: {
    category: "User navigates to assistance page",
    action: "The user clicks on Zenvoya assistance button",
    label: "today-zenvoya-assistance-click",
  },
    today_zenvoya_assistance_input_click: {
    category: "Today assistance",
    action: "User clicks on Zenvoya assistance input",
    label: "today-zenvoya-assistance-input-click",
  },
  today_explore_city_input_click: {
    category: "Today explore",
    action: "User clicks on explore city input",
    label: "today-explore-city-input-click",
  },
};
